import Swiper from "swiper"
import { methods } from '../includes/_methods'
import Blazy from 'blazy'
import 'jquery.scrollbar/jquery.scrollbar.min.js'


window._common = {
  scrollLock() {
    if (fesdDB.is.isMobile4) {
      bodyScroll.lock()
    }
    else {
      $('body').css('overflow','hidden')
    }
  },
  scrollUnlock() {
    const hasMenu = $('.main-menu').hasClass('active') ? true : false;
    if( !hasMenu ) {
      if (fesdDB.is.isMobile4) {
        bodyScroll.unlock()
      }
      else {
        $('body').attr('style', '')
      }
    }
  },
  // 滾動到目標位置
  scrollTarget(target, val=0){
    var $target = $(target);
    var offsetTop = $target.position().top-val;   
    $('html,body').animate(
        { scrollTop: offsetTop }, 
        { duration: 300 }
    );
  },
  // 共用 banner swiper
  commonSwiper(el) {
    const setting = {
      on: {
        init: function(){
          methods.getSlidesCount(this);
        },
        slideChangeTransitionStart: function () {
          let now = $(`${el} .swiper-page p.now`),
              index = Number($(`${el} .swiper-slide-active`).attr('data-swiper-slide-index'));
          // 頁碼
          now.text(`0${index + 1}`);
        },
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      lazy: {
        elementClass: 'bg-desktop',
        loadPrevNext: true
      },
      breakpoints: {
        320: {
          lazy: {
            elementClass: 'bg-mobile'
          },
        },
        768: {
          lazy: {
            elementClass: 'bg-desktop'
          },
        }
      },
      pagination: {
        el: `${el} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `${el} .swiper-button-next`,
        prevEl: `${el} .swiper-button-prev`,
      }
    }
    
    page(el);
    function page(el) {
      let len = $(`${el} .swiper-slide`).length,
          all = $(`${el} .swiper-page p.all`);
      if(len > 1) all.text(`0${len}`);
      else $(`${el} .swiper-page`).hide();
      // 啟動swiper
      const comSwiper = new Swiper(`${el} .swiper-container`, setting);
    }
  },
  // 共用 info-block swiper
  blockSwiper(el) {
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
        }
      },
      loop: true,
      autoplay: true,
      speed: 1200,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1
        },
        901: {
          slidesPerView: 2
        }
      },
      pagination: {
        el: `${el} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `${el} .swiper-button-next`,
        prevEl: `${el} .swiper-button-prev`,
      }
    }

    active(el);
    function active(el) {
      let len = $(`${el} .swiper-slide`).length;
      if(len >= 2) {
        const _blockSwiper = new Swiper(`${el} .swiper-container`, setting)
      }
      else if(len <= 1){
        $(el).addClass('one');
      }
    }
  },
  photoInfoSwiper(el) {
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
        }
      },
      loop: true,
      autoplay: true,
      speed: 1200,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1
        },
        1201: {
          slidesPerView: 2
        }
      },
      pagination: {
        el: `${el} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `${el} .swiper-button-next`,
        prevEl: `${el} .swiper-button-prev`,
      }
    }

    active(el);
    function active(el) {
      let len = $(`${el} .swiper-slide`).length;
      if(len >= 2) {
        const _blockSwiper = new Swiper(`${el} .swiper-container`, setting)
      }
      else if(len <= 1){
        $(el).addClass('one');
      }
    }
  },
  // 品牌共用 banner swiper
  brandBnSwiper(el) {
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
        },
        slideChangeTransitionStart: function () {
          let now = $(`${el} .swiper-page p.now`),
              index = Number($(`${el} .swiper-container .swiper-slide-active`).attr('data-swiper-slide-index'));
          if(index == 0) {
            now.text(`0${index + 1}`);
          }
          else if(index % 3 == 0) {
            // console.log('next')
            now.text(`0${index / 3 + 1}`);
          }
          
        }
      },
      autoplay: true,
      loop: true,
      speed: 1000,
      slidesPerView: 3,
      slidesPerGroup: 1,
      navigation: {
        nextEl: `${el} .swiper-button-next`,
        prevEl: `${el} .swiper-button-prev`,
      },
      pagination: {
        el: `${el} .swiper-pagination`,
        clickable: true
      }
    }

    page();
    // 頁碼
    function page() {
      let len = $(`${el} .swiper-slide`).length,
          all = $(`${el} .swiper-page p.all`),
          num = Math.ceil(len / 3);
      if(len > 3) all.text(`0${num}`);
      else $(`${el} .swiper-page`).hide();
      // 啟動swiper
      const overviewSwiper = new Swiper(`${el} .swiper-container`, setting);
    }
  },
  // 品牌選取顏色
  getColor(el) {
    const color = $(el).attr('data-color'),
          li = $(el).find('li');

    click();
    hover();

    function hover() {
      $(el).find('li').on('mouseenter',function(){
        $(this).css('background-color', color)
      }).on('mouseleave',function(){
        $(this).css('background-color', '#fff')
        $(this).removeClass('active')
      });
    }

    function click() {
      $(el).find('li.active').css('background-color', color)
      li.on('click',function(){
        console.log(color)
        if(!$(this).hasClass('active')){
          $(this).siblings().removeClass('active').css('background-color', '#fff')
          // $(this).addClass('active')
          $(this).css('background-color', color);
        }
      });
    }
  },
  // 普通下拉選單
  comDropdown(el) {
    let target = $(el);
    target.on('click',function(){
      if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $(this).siblings('ul').slideDown(400);
      }else{
        $(this).removeClass('active');
        $(this).siblings('ul').slideUp(400);
      }
    })
  },
  // faq
  faq(target, outer) {
    $(target).on('click',function() {
      if(!$(this).hasClass('active')) {
        $(this).siblings().removeClass('active');
        $(this).siblings().find('.text').slideUp(500);
        $(this).addClass('active');
        $(this).find('.text').slideDown(500);
      } else {
        $(this).removeClass('active');
        $(this).find('.text').slideUp(500);
      }
    });
    $(outer).on('click',function(e) {
      e.stopPropagation()
    })
    $('body').on('click',function() {
      $(target).removeClass('active');
      $(target).find('.text').slideUp(500);
    });
  },
  // 新聞總攬頁 判斷
  newsSetType() {
    let info = $('.info.typeA');

    info.each(function(i,el){
      if( i % 2 !== 0 ) $(el).addClass('reverse');
      else $(el).addClass('normal')
    });
  },
  // resize
  resize(fun) {
    let resize = false;
    let t;
    let doResize = fun;

    $(window).on('resize', function () {
      resize = true;
      clearTimeout(t);
      console.log('resize')
      t = setTimeout(doResize, 500);
    });
  },

  // tab4切換頁面
  tabPage(container, page, callback) {
    $(container).tab4Change(page, callback);
  },
  // 後端用
  backendAjax() {
    window._common.bLazy = new Blazy({
      offset: 100,
      success: function () { 
        //image load success
      }
    });
    $('[data-aost]').aost4();
  },
  // 執行燈箱
  activelibox(liboxName) {
    let $btn = $(`[data-open="${liboxName}"]`);
    $btn.on('click',function(){
      let liboxName = $(this).attr('data-open');
      let target = `[data-libox="${liboxName}"]`;
      _common.openlibox(target);
    });
    _common.closelibox(liboxName);
  },
  
  // _common.bkLibox("目標燈箱",'燈箱 data-libox 屬性',callback)
  bkLibox(libox,liboxName,callback) {
    _common.openlibox(libox);
    _common.closelibox(liboxName,callback);
  },
  // 開啟頁內燈箱
  openlibox(target) {
    let $target = $(target);
    $target.fadeIn(200).addClass('show');
    setTimeout(()=>{
      $target.addClass('in')
      methods.fixMobile100vh()
    },500);
    _common.scrollLock();
  },
  // 關閉頁內燈箱
  closeliboxFun(target) {
    let $target = $(`[data-libox="${target}"]`);
    $target.removeClass('in');
    setTimeout(()=>{
      $target.removeClass('show');
    },300)
    setTimeout(()=>{
      $target.hide()
    },700);
    _common.scrollUnlock();
  },
  closelibox(target,callback) {
    let $target = $(`[data-libox="${target}"]`);
    let close = $target.find('.libox-close');
    close.on('click',function(){
      _common.closeliboxFun(target);
      if(callback) callback();
      else return
    });
    $(`[data-libox="${target}"] .libox-wrap`).on('click',function(e){
      e.stopPropagation();
    });
    $target.on('click',function(){
      _common.closeliboxFun(target);
      if(callback) callback();
      else return
    });
    
  },

  // 主選單事件+語言列
  menuEvent: {
    // 語言列
    lang: function() {
      const target = $('.lang-btn');
      const target2 = $('.lang-content .lang-val');

      target.on('click', function(e) {
        e.stopPropagation();
        $(this).find('.lang-content').slideToggle(400);
        $(this).toggleClass('active');
      });

      target2.on('click', function(e) {
        let nowVal = $(this).text();
        $(this).parents('.lang-btn').find('.val').text('').text(nowVal);
      });

      $('body, .main-menu').on('click', () => {
        $('.lang-content').slideUp(400);
        $('.lang-btn').removeClass('active');
      });
    },

    // 主選單綁定
    menuOpen: function() {
      const menu = $('.main-menu');
      if(menu.hasClass('active')) return;
      menu.addClass('block');
      _common.scrollLock();
      setTimeout(() => {
        menu.addClass('active');
      }, 150);
    },

    menuClose: function() {
      const menu = $('.main-menu');
      menu.removeClass('active');
      _common.scrollUnlock();
      setTimeout(() => {
        menu.addClass('block');
      }, 3000);
    },

    menuBind: function() {
      const vm = this;
      $('.main-menu-btn').on('click', function() {
        vm.menuOpen();
      });
      $('.menu-close').on('click', function() {
        vm.menuClose();
      }); 
    },

    // 主選單 hover
    menuHover: function() {
      const target = $('.main-menu .menu-list');
      const image = $('.main-menu .menu-bg .image');
      target.on('mouseenter', function() {
        let src = $(this).attr('data-src');
        image.addClass('hide');
        setTimeout(() => {
          image.css('background-image', `url(${src})`);
          image.removeClass('hide')
        }, 400);
      });
      $('.main-menu .menu-lists').on('mouseleave', function() {
        setTimeout(() => {
          image.addClass('hide');
        }, 200);
      });
    },

    all() {
      $('.main-menu .scrollbar-macosx').scrollbar();
      this.lang();
      this.menuBind();
      this.menuHover();
    },
  },

  // 搜尋事件
  searchEvent: {
    // 主選單綁定
    searchOpen: function() {
      const search = $('.main-search');
      if(search.hasClass('active')) return;
      search.addClass('block');
      _common.scrollLock();
      setTimeout(() => {
        search.addClass('active');
      }, 150);
    },

    searchClose: function() {
      const search = $('.main-search');
      search.removeClass('active');
      _common.scrollUnlock();
      setTimeout(() => {
        search.addClass('block');
      }, 3000);
    },

    searchBind: function() {
      const vm = this;
      $('.main-search-btn').on('click', function() {
        vm.searchOpen();
      });
      $('.search-close').on('click', function() {
        vm.searchClose();
      }); 
    },

    keyword: function() {
      const keyword = $('.main-search-tool .label');
      const input = $('.main-search-tool input');
      keyword.on('click', function() {
        let val = $(this).text();
        input.val('').val(val);
      });
    },

    all: function() {
      $('.main-search .scrollbar-macosx').scrollbar();
      this.searchBind();
      this.keyword();
    },
  },

}